import { createContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { notifyIncomingWebSocketMessage } from 'store/ducks/yayWebSocket'
import YayWebSocket from 'lib/yayWebSocket'
import cookie from 'lib/cookie'
import { useCurrentUser } from 'store/api/yay/user'

export const YayWebSocketContext = createContext({
  ws: null,
  isConnected: false,
  isWebSocketOpen: false,
  latestMessage: null,
  connect: () => {},
  disconnect: () => {},
  subscribe: (channel: any) => {},
  unsubscribe: (channel: any) => {},
})

const webSocket = new YayWebSocket()

const YayWebSocketContextProvider = ({ children }) => {
  const { data: currentUser } = useCurrentUser()
  const dispatch = useDispatch()
  const [isConnected, setIsConnected] = useState(false)
  const [isWebSocketOpen, setIsWebSocketOpen] = useState(false)
  const [latestMessage, setLatestMessage] = useState(null)

  const onMessage = (data) => {
    try {
      const channel = JSON.parse(data?.identifier)?.channel
      if (channel) {
        dispatch(notifyIncomingWebSocketMessage(channel, data?.message))
        setLatestMessage({ channel, message: data?.message })
      }
    } catch (e) {
      console.error(e)
    }
  }

  const connectWebSocket = () => {
    webSocket
      .connect(cookie.accessToken.get())
      .then(() => {
        setIsConnected(true)
      })
      .catch((e) => {
        console.log(e)
        setIsConnected(false)
      })
  }

  useEffect(() => {
    if (currentUser?.id) {
      connectWebSocket()
    }

    return () => {
      if (webSocket?.ws !== null) {
        webSocket.disconnect()
      }
    }
  }, [currentUser?.id])

  useEffect(() => {
    if (isConnected) {
      webSocket.ws.onmessage = (event) => {
        const data = JSON.parse(event.data)
        if (data?.identifier && data?.message) {
          onMessage(data)
        }
      }

      webSocket.ws.onopen = () => {
        setIsWebSocketOpen(true)
      }

      webSocket.ws.onclose = () => {
        setIsWebSocketOpen(false)
      }
    }
  }, [isConnected])

  return (
    <YayWebSocketContext.Provider
      value={{
        ...webSocket,
        connect: connectWebSocket,
        isConnected,
        isWebSocketOpen,
        latestMessage,
      }}
    >
      {children}
    </YayWebSocketContext.Provider>
  )
}

export default YayWebSocketContextProvider
